import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/assets/css/style.css";
import "@/assets/css/reset.css";
// element 引入
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// import 'vue-googlemaps/dist/vue-googlemaps.css'
// import VueGoogleMaps from 'vue-googlemaps'
// Vue.use(VueGoogleMaps)




//导入axios
import axios from 'axios'
axios.defaults.baseURL = 'https://www.saijiekj.com/index.php/api/'
Vue.prototype.$http = axios


Vue.config.productionTip = false
/* userAgent 判断是手机端还是pc端 */
let userAgent = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
Vue.prototype.userAgent = userAgent
new Vue({
  router,
  store,
  data: function () {
    return {
      newVue: new Vue()
    }
  },
  render: h => h(App)
}).$mount('#app')
